
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Le duel SEA vs SEO : différences, avantages, inconvénients",
    description:
      "Découvrez les différences entre SEO et SEA pour choisir la meilleure stratégie de référencement adaptée à votre entreprise et atteindre vos objectifs.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
